import { useState } from 'react';

export interface IToggleControls {
  set: (val: boolean) => void;
  setOff: () => void;
  setOn: () => void;
  toggle: () => void;
}

export const useToggle = (initialValue = false): [boolean, IToggleControls] => {
  const [value, setValue] = useState<boolean>(initialValue);

  return [
    value,
    {
      set: (val) => setValue(val),
      setOff: () => setValue(false),
      setOn: () => setValue(true),
      toggle: () => setValue((v) => !v),
    },
  ];
};
